const dateConverter = (date) => {
    const year = date.slice(0, 4)
    return date.slice(4, 10).split("-").reverse().join('.') + year;
}

export default dateConverter;